import React, { useState, useEffect } from 'react';
import { View, StyleSheet, TouchableWithoutFeedback, Dimensions } from 'react-native';
import CustomText from '../customText/CustomText';
import DropDown from '../dropDownNavigation';
import theme from '../../constants/theme.style.js';

const window = Dimensions.get('window');
const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  containerHeader: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 70,
    borderBottomWidth: 0.3,
    borderBottomColor: theme.GREY_DARKER_COLOR_OPACITY,
    position: 'relative',
  },
  tabContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    paddingLeft: 20,
  },
  tab: {
    height: 70,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  tabItem: {
    height: 60,
    width: 70,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'center',
    position: 'relative',
  },
});

const CustomWebNavigation = (props) => {
  const { navigation } = props;
  const activeTabIndex = navigation.state.index;
  const [dimensions, setDimensions] = useState({ window });

  // eslint-disable-next-line no-shadow
  const onChange = ({ window }) => {
    setDimensions({ window });
  };

  useEffect(() => {
    Dimensions.addEventListener('change', onChange);
    return () => {
      Dimensions.removeEventListener('change', onChange);
    };
  });

  if (navigation.state !== null) {
    return (
      <View style={styles.containerHeader}>
        <View
          testID="tabContainer"
          style={[
            styles.tabContainer,
            {
              width: dimensions.window.width < 1200 ? '100%' : '60%',
              justifyContent: dimensions.window.width < 1200 ? 'flex-start' : 'space-evenly',
            },
          ]}
        >
          {navigation.state.routes.map((route, index) => {
            const isRouteActive = index === activeTabIndex;
            const tintColor = isRouteActive ? '#CBE54E' : theme.GREY_LIGHT_COLOR;

            const routeName = route.routeName.replace('_', ' ');

            if (routeName === 'Profile') {
              return null;
            }
            if (width > 800) {
              return (
                <TouchableWithoutFeedback
                  onPress={() => {
                    if (!isRouteActive) {
                      navigation.navigate(route.routeName);
                    }
                  }}
                  key={route.routeName}
                >
                  <View
                    style={[
                      styles.tabItem,
                      {
                        cursor: 'pointer',
                        marginRight: dimensions.window.width < 1200 ? 20 : 0,
                      },
                    ]}
                  >
                    <CustomText
                      style={{
                        fontSize: dimensions.window.width < 800 ? 13 : 17,
                        color: `${tintColor}`,
                        paddingLeft: 30,
                        paddingRight: 30,
                        fontWeight: `${isRouteActive ? 'bold' : 'normal'}`,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {routeName}
                    </CustomText>
                  </View>
                </TouchableWithoutFeedback>
              );
            }
            return null;
          })}
        </View>
        <DropDown nav={navigation} />
      </View>
    );
  }
  return <CustomText>404 Not Found</CustomText>;
};

export default CustomWebNavigation;
